

import env from 'Env';

const GIVEAWAY_ACTIONS_KEY = 'giveawayActions';
const MAX_GIVEAWAY_ACTIONS = env.algolia.maxGiveawayActions || 10;


/**
 * Retrieves the giveaway actions array from localStorage.
 * @returns {Array} The array of giveaway actions.
 */
const getGiveawayActions = () => {
  try {
    const actions = JSON.parse(localStorage.getItem(GIVEAWAY_ACTIONS_KEY)) || [];
    return actions;
  } catch (e) { /* */ }
  return [];
};

/**
 * Saves the giveaway actions array to localStorage.
 * Ensures the list does not exceed the maximum allowed entries.
 * Removes the oldest entry if the list is too long.
 * @param {Array} actions - The array of giveaway actions to save.
 */
const persistGiveawayActions = (actions) => {
  if ((actions || []).length > MAX_GIVEAWAY_ACTIONS) {
    actions.shift();
  }

  localStorage.setItem(GIVEAWAY_ACTIONS_KEY, JSON.stringify(actions));
};

export {
  getGiveawayActions,
  persistGiveawayActions,
};
